/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmCreateDto } from '../../models/farm-create-dto';
import { FarmDto } from '../../models/farm-dto';

export interface FarmControllerCreate$Params {
      body: FarmCreateDto
}

export function farmControllerCreate(http: HttpClient, rootUrl: string, params: FarmControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
  const rb = new RequestBuilder(rootUrl, farmControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FarmDto>;
    })
  );
}

farmControllerCreate.PATH = '/api/farm';
